<template>
  <div class="youkequntihuaxiang">
    <ul>
      <li @click="goDetailLoc(101)">
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light"></div>
            <div class="icon">
              <img src="../../assets/youkequntihuaxiang/icon1.png" />
            </div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">性别</div>
      </li>
      <li @click="goDetailLoc(101)">
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light"></div>
            <div class="icon">
              <img src="../../assets/youkequntihuaxiang/icon2.png" />
            </div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">年龄</div>
      </li>
      <li @click="goDetailLoc(101, -400)">
        <div class="line"></div>
        <div class="bg">
          <div class="list-bg">
            <div class="light"></div>
            <div class="icon">
              <img src="../../assets/youkequntihuaxiang/icon3.png" />
            </div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">婚姻</div>
      </li>
      <li @click="goDetailLoc(101, -400)">
        <div class="bg">
          <div class="list-bg">
            <div class="light"></div>
            <div class="icon">
              <img src="../../assets/youkequntihuaxiang/icon4.png" />
            </div>
          </div>
          <div class="light-bar"></div>
        </div>
        <div class="text">兴趣</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "YoukeQuntiHuaxiang",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goDetailLoc(code, val) {
      if(val) {
        this.$store.commit("setChildModalOffsetY", val);
      } else {
        this.$store.commit("setChildModalOffsetY", 0);
      }
      this.$store.commit("setChildModalTitle", this.title);
      this.$store.commit("setChildModalCode", code);
      this.$store.commit("setChildModalShow");
    }
  }
};
</script>

<style scoped lang="less">
.youkequntihuaxiang {
  ul {
    li {
      cursor: pointer;
      width: 25%;
      height: 1.8rem;
      float: left;
      position: relative;
      .line {
        width: 0.02rem;
        height: 1.61rem;
        background: url(../../assets/youkequntihuaxiang/line.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0.06rem;
        right: 0;
      }
      .bg {
        width: 0.975rem;
        height: 1.8rem;
        margin: 0 auto;
        .list-bg {
          width: 0.975rem;
          height: 0.975rem;
          background: url(../../assets/youkequntihuaxiang/list_bg.png);
          background-size: 100%;
          position: relative;
          overflow: hidden;
          .icon {
            width: 0.48rem;
            height: 0.48rem;
            position: absolute;
            left: 50%;
            margin-left: -0.24rem;
            top: 0.24rem;
            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          .light {
            width: 0.975rem;
            height: 0.975rem;
            background: url(../../assets/youkequntihuaxiang/light.png) no-repeat;
            background-size: 1100% 100%;
            animation: bird-slow 1s steps(10) infinite;
          }
        }
        .light-bar {
          width: 0.46rem;
          height: 1.1rem;
          background-image: linear-gradient(
            to bottom,
            rgba(34, 84, 178, 0.3),
            rgba(34, 84, 178, 0.01)
          );
          margin: -0.3rem auto 0;
        }
      }
      .text {
        position: absolute;
        bottom: 0.4rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.2rem;
      }
    }
  }
}
@media screen and (max-height: 863px) {
  .youkequntihuaxiang ul li {
    height: 1.6rem;
    .text {
      bottom: 0.3rem;
    }
    .bg .light-bar {
      height: 0.9rem;
    }
  }
}
</style>
